import SeatsLeftContainer from 'components/widget/SeatsLeft/SeatsLeftContainer';
import { isMoreAvailableSeats } from 'components/event/Registration';
import { decl } from 'utils/helpers';
import { isMoreOrLessThanCurrent } from 'utils/dates';

interface IProps {
  capacity?: number;
  number?: number;
  enrollFinishDate?: string;
}

export default function SeatsLeft({
  number,
  capacity,
  enrollFinishDate,
}: IProps) {
  if (!number) return null;

  const isSignUpClosed: boolean = !!(
    enrollFinishDate && isMoreOrLessThanCurrent(enrollFinishDate)
  );

  return (
    <SeatsLeftContainer>
      {isSignUpClosed ? (
        <>Запись закрыта</>
      ) : isMoreAvailableSeats({ capacity: capacity!, left: number }) ? (
        <>
          {number > 0 ? (
            <>
              Осталось {number} {decl(number, ['место', 'места', 'мест'])}
            </>
          ) : (
            <>Мест больше нет</>
          )}
        </>
      ) : (
        <>Запись идет</>
      )}
    </SeatsLeftContainer>
  );
}
